import { render, staticRenderFns } from "./AddDepositModal.vue?vue&type=template&id=3a0ffc6d&scoped=true"
import script from "./AddDepositModal.vue?vue&type=script&lang=ts"
export * from "./AddDepositModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0ffc6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0ffc6d')) {
      api.createRecord('3a0ffc6d', component.options)
    } else {
      api.reload('3a0ffc6d', component.options)
    }
    module.hot.accept("./AddDepositModal.vue?vue&type=template&id=3a0ffc6d&scoped=true", function () {
      api.rerender('3a0ffc6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/AddDepositModal.vue"
export default component.exports